import { render } from "./AreaTable.vue?vue&type=template&id=a118db98&scoped=true"
import script from "./AreaTable.vue?vue&type=script&lang=js"
export * from "./AreaTable.vue?vue&type=script&lang=js"

import "./AreaTable.vue?vue&type=style&index=0&id=a118db98&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a118db98"]])

export default __exports__